import { createContext, useContext, useEffect, useRef, useState } from "react";
import Lenis from "lenis";

const LenisContext = createContext(null);
export const useLenis = () => useContext(LenisContext);

export const LenisProvider = ({ children }) => {
    const [lenis, setLenis] = useState(null);
    const lenisRef = useRef(null);

    useEffect(() => {
        const l = new Lenis({ lerp: 0.09, smoothWheel: true });
        lenisRef.current = l;
        setLenis(l);
        let raf;
        const loop = (t) => {
            l.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            l.destroy();
            lenisRef.current = null;
        };
    }, []);

    const scrollTo = (target) => {
        if (lenisRef.current) lenisRef.current.scrollTo(target, { offset: -90 });
        else document.querySelector(target)?.scrollIntoView({ behavior: "smooth" });
    };

    return <LenisContext.Provider value={{ lenis, scrollTo }}>{children}</LenisContext.Provider>;
};

export default LenisProvider;
